import React from 'react'
import styles from './SectionSelection.module.css'
import AuditTypeDropdown from './AuditTypeDropdown'
import SectionDropdown from './SectionDropdown'
import { STATUS } from '../../../global/types/audit'

export type AuditType = STATUS

interface SectionSelectionProps {
  auditType: AuditType | null
  sectionKey: string | null
  auditTypes: Array<{ key: AuditType; label: string }>
  sections: Array<{ key: string; title: string }>
  sectionPromptStatus: Record<
    string,
    { hasPrompt: boolean; isEnabled: boolean }
  >
  onAuditTypeChange: (auditType: AuditType) => void
  onSectionChange: (sectionKey: string) => void
}

function SectionSelection({
  auditType,
  sectionKey,
  auditTypes,
  sections,
  sectionPromptStatus,
  onAuditTypeChange,
  onSectionChange,
}: SectionSelectionProps) {
  return (
    <>
      <div className={styles.navigationDropdowns}>
        <AuditTypeDropdown
          value={auditType}
          onChange={onAuditTypeChange}
          auditTypes={auditTypes}
        />

        <SectionDropdown
          value={sectionKey}
          onChange={onSectionChange}
          sections={sections}
          auditType={auditType}
          sectionPromptStatus={sectionPromptStatus}
        />
      </div>

      {!auditType || !sectionKey ? (
        <div className={styles.emptyState}>
          <h2>Select a Section</h2>
          <p>Choose an audit type and section above to configure AI prompts.</p>
        </div>
      ) : null}
    </>
  )
}

export default SectionSelection
